import {propertyOffer} from "@pg-mono/string-utils";

export const FAVORITES_LABELS = {
    ADD_OFFERS_BUTTON: "Dodaj oferty",
    ADD_PARAMETER_BUTTON: "Dodaj kolejny parametr, który chcesz porównać",
    ADD_TO_COMPARATOR_BUTTON: "Dodaj ofertę\ndo porównywarki",
    ADD_TO_COMPARATOR_CONFIRM: (count: number) => `Dodaj do porównywarki (${count})`,
    ADD_TO_COMPARATOR_SHEET_SUBTITLE: "Kliknij na elementy, które chcesz dodać do porównywarki.",
    ADD_TO_COMPARATOR_SHEET_TITLE: "Wybierz nieruchomości, które chcesz porównać",
    ASK_OFFER_BUTTON: "Zapytaj o ofertę",
    ASK_OFFER_BUTTON_SENT: "Wysłano zapytanie",
    BACK_BUTTON: "Powróć do listy",
    CANCEL_BUTTON: "Cofnij",
    CLOSE_BUTTON: "Zamknij",
    COMPARE_BUTTON: "Porównaj oferty",
    COMPARE_SELECTED_BUTTON: "Porównaj wybrane oferty",
    COMPARATOR_COLUMN_REORDER_ERROR: "Nie udało się zapisać kolejności ofert. Spróbuj ponownie.",
    COMPARATOR_ROW_REORDER_ERROR: "Nie udało się zapisać kolejności parametrów. Spróbuj ponownie.",
    COMPARATOR_UPDATE_ERROR: "Nie udało się zaktualizować porównywarki. Spróbuj ponownie.",
    FAVORITE_ADD_ERROR: "Nie udało się dodać oferty do ulubionych. Spróbuj ponownie.",
    FAVORITE_ADD_SUCCESS: "Dodano ofertę do ulubionych",
    FAVORITE_REMOVE_ERROR: "Nie udało się usunąć oferty z ulubionych. Spróbuj ponownie.",
    FAVORITE_REMOVE_SUCCESS: "Usunięto ofertę z ulubionych",
    COMPARATOR_ASK_OFFER_BUTTON: "Zapytaj",
    COMPARATOR_ASK_OFFER_BUTTON_SENT: "Wysłano",
    COMPARATOR_REMOVE_BUTTON: "Usuń z porównania",
    FEATURE_PICKER_SAVE: (count: number) => `Zapisz (${count})`,
    FEATURE_PICKER_SEARCH_EMPTY: "Nie znaleziono parametrów",
    FEATURE_PICKER_SEARCH_PLACEHOLDER: "Znajdź parametr, który chcesz porównać",
    FEATURE_PICKER_SHEET_SUBTITLE: "Dodaj lub usuń parametry, które chcesz porównać. Wybierz te, które są dla Ciebie kluczowe przy podejmowaniu decyzji.",
    FEATURE_PICKER_SHEET_TITLE: "Zarządzaj parametrami porównywarki",
    GTM_OFFER_STATUS: "ulubiona",
    LIST_NAME: "Ulubione",
    LOADING: "Wczytuję ulubione...",
    SELECT_OFFER: (offerName: string) => `Zaznacz ofertę do porównania: ${offerName}`,
    SELECTION_MODE_TITLE: "Wybierz oferty, które chcesz porównać",
    SELECTION_SUMMARY: (selectedCount: number, totalCount: number) =>
        `Dodano do porównania ${selectedCount}/${totalCount} ${propertyOffer.accusative(totalCount)}`
} as const;
import {propertyOffer} from "@pg-mono/string-utils";

export const FAVORITES_LABELS = {
    ADD_OFFERS_BUTTON: "Dodaj oferty",
    ADD_PARAMETER_BUTTON: "Dodaj kolejny parametr, który chcesz porównać",
    ADD_TO_COMPARATOR_BUTTON: "Dodaj ofertę\ndo porównywarki",
    ADD_TO_COMPARATOR_CONFIRM: (count: number) => `Dodaj do porównywarki (${count})`,
    ADD_TO_COMPARATOR_SHEET_SUBTITLE: "Kliknij na elementy, które chcesz dodać do porównywarki.",
    ADD_TO_COMPARATOR_SHEET_TITLE: "Wybierz nieruchomości, które chcesz porównać",
    ASK_OFFER_BUTTON: "Zapytaj o ofertę",
    ASK_OFFER_BUTTON_SENT: "Wysłano zapytanie",
    BACK_BUTTON: "Powróć do listy",
    CANCEL_BUTTON: "Cofnij",
    CLOSE_BUTTON: "Zamknij",
    COMPARE_BUTTON: "Porównaj oferty",
    COMPARE_SELECTED_BUTTON: "Porównaj wybrane oferty",
    COMPARATOR_COLUMN_REORDER_ERROR: "Nie udało się zapisać kolejności ofert. Spróbuj ponownie.",
    COMPARATOR_ROW_REORDER_ERROR: "Nie udało się zapisać kolejności parametrów. Spróbuj ponownie.",
    COMPARATOR_UPDATE_ERROR: "Nie udało się zaktualizować porównywarki. Spróbuj ponownie.",
    FAVORITE_ADD_ERROR: "Nie udało się dodać oferty do ulubionych. Spróbuj ponownie.",
    FAVORITE_ADD_SUCCESS: "Dodano ofertę do ulubionych",
    FAVORITE_REMOVE_ERROR: "Nie udało się usunąć oferty z ulubionych. Spróbuj ponownie.",
    FAVORITE_REMOVE_SUCCESS: "Usunięto ofertę z ulubionych",
    COMPARATOR_ASK_OFFER_BUTTON: "Zapytaj",
    COMPARATOR_ASK_OFFER_BUTTON_SENT: "Wysłano",
    COMPARATOR_REMOVE_BUTTON: "Usuń z porównania",
    FEATURE_PICKER_SAVE: (count: number) => `Zapisz (${count})`,
    FEATURE_PICKER_SEARCH_EMPTY: "Nie znaleziono parametrów",
    FEATURE_PICKER_SEARCH_PLACEHOLDER: "Znajdź parametr, który chcesz porównać",
    FEATURE_PICKER_SHEET_SUBTITLE: "Dodaj lub usuń parametry, które chcesz porównać. Wybierz te, które są dla Ciebie kluczowe przy podejmowaniu decyzji.",
    FEATURE_PICKER_SHEET_TITLE: "Zarządzaj parametrami porównywarki",
    GTM_OFFER_STATUS: "ulubiona",
    LIST_NAME: "Ulubione",
    LOADING: "Wczytuję ulubione...",
    SELECT_OFFER: (offerName: string) => `Zaznacz ofertę do porównania: ${offerName}`,
    SELECTION_MODE_TITLE: "Wybierz oferty, które chcesz porównać",
    SELECTION_SUMMARY: (selectedCount: number, totalCount: number) =>
        `Dodano do porównania ${selectedCount}/${totalCount} ${propertyOffer.accusative(totalCount)}`
} as const;
